<template>
  <el-card
    class="firstlog-user-dimension"
    shadow="never"
    :body-style="{ padding: inner ? '10px' : '0' }"
  >
    <el-table
      :data="items0"
      :row-key="r => `${r.uname}_${r.type}_${inner}`"
      size="mini"
      :show-header="!inner"
      v-bind="tableAttrs"
    >
      <el-table-column v-if="!inner" type="expand">
        <FirstlogPathDimensionTable
          slot-scope="scope"
          :items="scope.row.parts"
          inner
        />
      </el-table-column>

      <el-table-column v-else label="No" width="50" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>

      <el-table-column label="用户名" width="130" show-overflow-tooltip>
        <div slot-scope="s">
          <span
            :class="{ 'is-click': s.row.id }"
            @click="s.row.id && openUser(s.row)"
            >{{ s.row.uname }}</span
          >
        </div>
      </el-table-column>

      <el-table-column label="类型" width="80" align="center">
        <div slot-scope="s">
          <span>{{ s.row.type | userType }}</span>
        </div>
      </el-table-column>

      <el-table-column label="手机号">
        <div slot-scope="s">
          <span>{{ s.row.mobile }}</span>
        </div>
      </el-table-column>

      <el-table-column label="公司名">
        <div slot-scope="s">
          <span>{{ s.row.companyName }}</span>
        </div>
      </el-table-column>

      <el-table-column label="数量(成功/总数量)" width="180" align="right">
        <div slot-scope="s" class="item-right">
          <span class="info-successful-count">{{ s.row.successfulCount }}</span>
          <span>/</span>
          <span class="info-count">{{ s.row.count }}</span>
        </div>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  name: 'FirstlogUserDimensionTable',

  components: {
    FirstlogPathDimensionTable: () =>
      import('./FirstlogPathDimensionTable.vue'),
  },

  filters: {
    userType(t) {
      return t === 2 ? 'API' : t === 1 ? 'WEB' : ''
    },
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    inner: {
      type: Boolean,
    },

    component: {
      type: String,
    },
  },

  computed: {
    tableAttrs() {
      return this.inner
        ? {}
        : {
            'max-height': 400,
            height: 400,
          }
    },

    items0() {
      const items0 = []

      for (const item of this.items || []) {
        items0.push({
          ...item,
          ...(item.user || {}),
        })
      }
      return items0
    },
  },

  methods: {
    openUser(row) {
      this.$emit('open-user', row)
    },
  },
}
</script>

<style lang="scss" scoped>
.firstlog-user-dimension {
  border: none;

  .item-right {
    text-align: right;
  }

  .info-successful-count {
    font-weight: bold;
    margin-right: 5px;
  }

  .info-count {
    font-weight: bold;
    margin-left: 5px;
  }

  .is-click {
    color: #409eff;
    position: relative;
    cursor: pointer;

    &:hover {
      color: #66b1ff;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        height: 0;
        bottom: 0;
        border-bottom: 1px solid #409eff;
      }
    }
  }
}
</style>
